import React, { useEffect } from "react";
import { TextField } from "@mui/material";
// import QuotationDocs from "./QuotationDocs";
// import RelatedDocs from "./RelatedDocs";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";


export const OtherDetailsTab = ({ selectedLead }) => {


  // useEffect

  const activities = [
    {
      date: "2025-01-25",
      activity: "Created Lead",
      note: "Lead created by Admin",
    },
    {
      date: "2025-01-26",
      activity: "Updated Lead",
      note: "Changed status from 'New' to 'Qualified'",
    },
    {
      date: "2025-01-27",
      activity: "Follow-up Added",
      note: "Scheduled a follow-up call for 2025-02-01",
    },
  ];

  return (
    <div className="flex flex-col gap-4">
      {/* Quotation and Related Docs */}
      {/* <QuotationDocs /> */}
      {/* <RelatedDocs selectedLead={selectedLead} /> */}

      {/* Activity History */}
      <div>
        <h2 className="text-lg font-normal mb-2">Activity History</h2>
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>Activity</TableCell>
                <TableCell>Note</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {activities.map((activity, index) => (
                <TableRow key={index}>
                  <TableCell>{activity.date}</TableCell>
                  <TableCell>{activity.activity}</TableCell>
                  <TableCell>{activity.note}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
};

  